import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, filter, take } from 'rxjs/operators';

import { CompanyStore } from '../store/company.store';

@Injectable({
  providedIn: 'root',
})
export class RegisterEnabledGuard {
  companyStore = inject(CompanyStore);
  router = inject(Router);

  constructor() {}
  private checkIfCanRegister() {
    return this.companyStore.companyObservable().pipe(
      filter((company) => company !== null),
      take(1),
      map((companyInfo: any) => {
        // debugger;
        const canRegister = companyInfo?.company?.client_registration;
        if (!canRegister) {
          this.router.navigate(['/']);
        }
        return canRegister;
      }),
    );
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkIfCanRegister();
  }
  canLoad(): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkIfCanRegister();
  }
}
